/**
 * The unique identity symbol for the react context service.
 */
export const ReactContextServiceIdentity = Symbol("ReactContextService");
//# sourceMappingURL=reactContextService.js.map